import { MapperBase } from '../../utilities/mapper-base';
import { BriefcaseJobResource } from '../resource/briefcase-job.resource';
import { Briefcase } from '../ui/briefcase.model';
import { FormattingUtility } from '../../utilities/formatting.utility';

export class BriefcaseJobResourceToBriefcaseJobMapper extends MapperBase<BriefcaseJobResource, Briefcase> {
    map(source: BriefcaseJobResource): Briefcase {
        const dest = new Briefcase();
        dest.title = source.title;
        dest.id = source.id;
        dest.comments = source.comments;
        dest.createdByEmail = source.createdByEmail;
        dest.createdAt = source.createdAt ? new Date(source.createdAt) : null;
        dest.customDesignation = source.customDesignation;
        dest.hasBatesStampPages = source.hasBatesStampPages;
        dest.totalDocuments = source.totalDocuments;
        dest.size = FormattingUtility.bytesAsGB(source.size);
        dest.status = source.status;
        dest.sharedId = source?.sharedId;
        dest.isShared = source.isShared;
        return dest;
    }
}
